module.exports = __webpack_public_path__ + "img/tool_download_black.86fb7f3d.png";